import { createFileRoute } from '@tanstack/react-router'

/**
 * A raiz é o `redirect_uri` do client no Keycloak e o endereço que o usuário
 * digita — mas não é destino de ninguém: `useGovBrSession`, montado na rota-raiz,
 * encaminha para o login ou para a lista de cadastros assim que a sessão é
 * conhecida. O que fica aqui é só o que se vê nesse intervalo.
 */
function Entrada() {
  return (
    <p role="status" className="mx-auto max-w-6xl px-6 py-12 text-base text-muted-foreground">
      Verificando sua sessão…
    </p>
  )
}

export const Route = createFileRoute('/')({ component: Entrada })
